<template lang="pug">
  modal.modal(:title='$t("shareResource.title")' @closeModal='hideElement({ element: "shareResourceModal" })')
    transition(name='tooltip')
      .student-tooltip.row.middle(v-if='showTooltip')
        simple-svg.white-icon.m-right-1(:filepath='unfilledCheckIcon' :width='"16px"' :height='"16px"')
        p.text-normal.bold.white.m4-bottom-1 {{ $t('shareResource.linkCopied')}}
    .width-100(v-if='!type')
      h2.text-normal.blue.bold.m-bottom-2.m-top-1 {{ $t('shareResource.chooseShareType') }}
      .row.middle.selectors
        .selector.item-1(@click='selectType("students")')
          h2.title-small.bold.m-bottom-05 {{ $t('shareResource.students') }}
          p.text-normal.dark-gray {{ $t('shareResource.studentsDescription') }}
        .selector.item-1(@click='selectType("schoolGroup")')
          h2.title-small.bold.m-bottom-05 {{ $t('shareResource.schoolGroup') }}
          p.text-normal.dark-gray {{ $t('shareResource.schoolGroupDescription') }}
    .column.middle(v-else)
      students-share(v-if='type === "students"' @back='goBack' @showTooltip='displayTooltip')
      school-group-share(v-if='type === "schoolGroup"' @back='goBack')
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Modal from '../Modal'
import unfilledCheckIcon from '@/assets/ic_check_base.svg'
import SchoolGroupShare from './ShareResourceModal/SchoolGroupShare'
import StudentsShare from './ShareResourceModal/StudentsShare'

export default {
  components: { Modal, SchoolGroupShare, StudentsShare },
  data() {
    return {
      type: null,
      unfilledCheckIcon,
      showTooltip: false,
      successMessage: this.$t('shareResource.doneModal')
    }
  },
  mounted() {
    if (this.modalProps.isTeacherTraining) {
      this.type = 'schoolGroup'
    }
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.shareResourceModal.props
    })
  },
  methods: {
    ...mapActions(['hideElement']),
    selectType(type) {
      this.type = type
    },
    goBack() {
      this.type = null
    },
    displayTooltip() {
      this.showTooltip = true
      setTimeout(() => { this.showTooltip = false }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';

.selectors{
  align-items: stretch;
  gap: 10px;
  .selector{
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid $light-gray;
    padding: 20px;
    box-shadow: 0 2px 8px 0 $shadow-gray;
  }
}

.modal{
  --max-width: 680px;
}

.link-container {
  margin-top: 35px;
  position: relative;
}

.student-tooltip {
  background-color: $blue;
  box-shadow: 0 2px 8px 0 $shadow-gray;
  max-width: 300px;
  padding: 15px;
  position: absolute;
  right: 50%;
  height: 40px;
  border-radius: 5px;
  transform: translateX(50%);
  bottom: 50px;
  transition: opacity 0.5s ease;
}

.tooltip-enter,
.tooltip-leave-active {
  opacity: 0;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: $white;
}

::-webkit-scrollbar-thumb {
  background: $gray;
  border-radius: 5px;
  height: 72px;
}

.error-desc {
  margin-right: auto;
}
</style>
